<template>
  <v-data-table
    :headers="colunas"
    :items="casos"
    :loading="carregando"
    :items-per-page="-1"
    :height="altura"
    :fixed-header="!!altura"
    loading-text="Carregando alunos..."
    :no-data-text="carregando ? 'Carregando alunos...' : mensagemVazia"
    hide-default-footer
    disable-sort
    dense
    class="elevation-0 tabela-busca-ativa"
  >
    <template v-slot:item.aluno="{ item }">
      <div class="font-weight-medium texto-truncado" :title="item.aluno">{{ item.aluno }}</div>
      <div
        v-if="mostrarTurma"
        class="text-caption grey--text texto-truncado"
        :title="`${item.turma} — ${item.escola}`"
      >
        {{ item.turma }} — {{ item.escola }}
      </div>
    </template>

    <template v-slot:item.faltas_injustificadas="{ item }">
      <e-faltas-do-limite
        :faltas="item.faltas_injustificadas"
        :limite="item.limite_faltas"
        :percentual="item.percentual_limite_faltas"
      />
    </template>

    <template v-slot:item.ultima_presenca="{ item }">
      {{ formatarData(item.ultima_presenca) }}
    </template>

    <template v-slot:item.categoria="{ item }">
      <e-chip-risco-evasao
        :categoria="item.categoria"
        :categoria-rotulo="item.categoria_rotulo"
        :status="item.status"
      />
    </template>

    <template v-slot:item.acoes="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            x-small
            color="primary"
            :aria-label="`Visualizar detalhes de ${item.aluno}`"
            v-bind="attrs"
            v-on="on"
            :to="{ name: 'buscaAtiva.detalhesAluno', params: { caso_id: item.id } }"
          >
            <v-icon small>mdi-eye</v-icon>
          </v-btn>
        </template>
        <span>Visualizar detalhes</span>
      </v-tooltip>
    </template>

    <template v-slot:no-data>
      <div v-if="erro" class="py-6 text-center" role="alert">
        <v-icon color="error" class="mb-1">mdi-alert-circle-outline</v-icon>
        <div class="error--text mb-2">{{ erro }}</div>
        <v-btn small outlined color="primary" @click="$emit('tentar-novamente')">
          Tentar novamente
        </v-btn>
      </div>
      <div v-else class="py-6 grey--text text-center" role="status">{{ mensagemVazia }}</div>
    </template>
  </v-data-table>
</template>

<script>
import EChipRiscoEvasao from "@/components/BuscaAtiva/EChipRiscoEvasao.vue";
import EFaltasDoLimite from "@/components/BuscaAtiva/EFaltasDoLimite.vue";

const COLUNAS = [
  { text: "Aluno", value: "aluno", width: 380 },
  { text: "Matrícula", value: "matricula", width: 110 },
  { text: "Faltas Injustificadas", value: "faltas_injustificadas", width: 180 },
  { text: "Dias Consecutivos", value: "dias_consecutivos_ausencia_total", align: "center" },
  { text: "Última Presença", value: "ultima_presenca", align: "center" },
  { text: "Risco de Evasão", value: "categoria", align: "center", width: 200 },
  { text: "Ações", value: "acoes", align: "center", width: 80 },
];

export default {
  name: "ETabelaAlunosEmRisco",
  components: { EChipRiscoEvasao, EFaltasDoLimite },
  props: {
    casos: { type: Array, default: () => [] },
    carregando: { type: Boolean, default: false },
    mostrarTurma: { type: Boolean, default: false },
    mensagemVazia: { type: String, default: "Nenhum aluno encontrado." },
    erro: { type: String, default: null },
    altura: { type: [Number, String], default: null },
  },
  data() {
    return { colunas: COLUNAS };
  },
  methods: {
    formatarData(data) {
      if (!data) return "- - -";
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
  },
};
</script>

<style scoped>
.tabela-busca-ativa ::v-deep th {
  white-space: nowrap;
}
/* Nome do aluno e escola completos: quebra de linha em vez de reticências. */
.texto-truncado {
  min-width: 300px;
  white-space: normal;
  overflow-wrap: anywhere;
}
</style>
